
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock";
import { useEffect } from "react";

import darkTheme from "../../../images/svg/layouts/darkTheme.svg"
import lightTheme from "../../../images/svg/layouts/lightTheme.svg"
import otoTheme from "../../../images/svg/layouts/otoTheme.svg"
import Btn from "../../shared/button/Btn";
import { useDispatch } from "react-redux";
import { handleCustomizer, handleGarageStats, handleSidebar, handleTheme, handleTopStages } from "../../../features/layout/layoutSlice";
import TopbarOpenSvg from "../../icons/layouts/TopbarOpenSvg";
import TopbarCloseSvg from "../../icons/layouts/TopbarCloseSvg";
import SidebarOpenSvg from "../../icons/layouts/SidebarOpenSvg";
import SidebarIconSvg from "../../icons/layouts/SidebarIconSvg";
import { BsCheck2 } from "react-icons/bs";
import { useSelector } from "react-redux";

const Container = styled.div`
    width: 360px;
    background-color: ${({theme}) => theme.mainBgColor};
    z-index: 999;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    color: ${({theme}) => theme.mainTextColor};
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    overflow: auto;


    .top-container{
        width: 100%;
        padding: 20px 10px;
        background-color: var(--color-main);

        h3{
            color: #fff;
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-xl);
        }
    }

    .customizer-item-list{
        display: flex;
        flex-direction: column;
        margin: 20px 0;
        
        .customizer-item{
            width: 100%;
            padding: 10px 20px;

            .customizer-item-top{

                border-bottom: 1px solid ${({theme}) => theme.mainTextColor};
                padding-bottom: 5px;
                margin-bottom: 15px;
            
                .title{
                    font-size: var(--font-size-md);
                    font-weight: var(--font-weight-lg);
                }
            }
                
            .content-list{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;

                .content-list-item{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-bottom: 20px;
                    width: calc(50% - 10px);
                    cursor: pointer;

                    img{
                        width: 100%;
                        border: 1px solid transparent;
                        border-radius: 10px;

                        &:hover{
                        border-color: ${({theme}) => theme.mainTextColor};
                    }

                    }

                    .name{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                        padding: 10px 0;
                    }
                }
            }


        }
    }

    .bottom-container{
        margin-top: auto;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
    }
`

const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    .box{
        width: 25px;
        height: 25px;
        border-radius: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid ${({theme}) => theme.mainTextColor};
        border: ${({isChecked}) => !isChecked ? `1px solid ${({theme}) => theme.mainTextColor}` : "none"};
        background-color: ${({theme, isChecked}) => isChecked ? "var(--color-main)" : theme.mainBgColor};

        .check-icon{
            font-size: 1.4rem;
            fill: #fff;
        }
    }

    span{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
    }
`

const themeList = [
    {
        id: 1,
        text: "Açık Tema",
        img: lightTheme,
        keyData: "light"
    },
    {
        id: 2,
        text: "Koyu tema",
        img: darkTheme,
        keyData: "dark"

    },
    {
        id: 3,
        text: "Cihaz Teması",
        img: otoTheme,
        keyData:"system"
    }
]

const yanMenuList = [
    {
        id: 1,
        text: "Açık Menü",
        img: <SidebarOpenSvg/>,
        keyData: "wide"
    },
    {
        id: 2,
        text: "İkonik Menü",
        img: <SidebarIconSvg/>,
        keyData: "sm-icon"
    },
    // {
    //     id: 3,
    //     text: "Kapalı",
    //     img: null,
    //     keyData: "hidden"
    // },
]

const topMenuList = [
    {
        id: 1,
        text: "Açık",
        img: <TopbarOpenSvg/>,
        keyData: true
    },
    {
        id: 2,
        text: "Kapalı",
        img: <TopbarCloseSvg/>,
        keyData: false
    },
]


const CustomizerContainer = () => {

    const dispatch = useDispatch()

    const { lockScroll, unlockScroll } = useScrollLock();

    const {garageStatsState} = useSelector(state => state.layout)

    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! handleGarageStats
  return (
    <Container>
        <div className="top-container">
            <h3>Ayarlar</h3>
        </div>
        <div className="customizer-item-list">
            <div className="customizer-item">
                <div className="customizer-item-top">
                    <div className="title">Tema</div>
                </div>
                <div className="content-list">
                    {
                        themeList.map((item) => (
                            <div className="content-list-item" onClick={() => dispatch(handleTheme(item.keyData))}>
                                <img src={item.img} alt={item.text} />
                                <div className="name">{item.text}</div>
                            </div>
                        ))
                    }
                </div>
            </div>

            <div className="customizer-item">
                <div className="customizer-item-top">
                    <div className="title">Yan Menü</div>
                </div>
                <div className="content-list">
                    {
                        yanMenuList.map((item) => (
                            <div className="content-list-item" onClick={() => dispatch(handleSidebar(item.keyData))}>
                                {item.img}
                                <div className="name">{item.text}</div>
                            </div>
                        ))
                    }
                </div>
            </div>

            <div className="customizer-item">
                <div className="customizer-item-top">
                    <div className="title">Sevkiyat Aşamaları</div>
                </div>
                <div className="content-list">
                    {
                        topMenuList.map((item) => (
                            <div className="content-list-item" onClick={() => dispatch(handleTopStages(item.keyData))}>
                                {item.img}
                                <div className="name">{item.text}</div>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className="customizer-item">
                <div className="customizer-item-top">
                    <div className="title">Garaj Yoğunluk Bilgisi</div>
                </div>
                <CheckboxContainer isChecked={garageStatsState === "open"}>
                    <button className="box" onClick={() => dispatch(handleGarageStats(garageStatsState === "open" ? "close" : "open"))}>
                        <BsCheck2 className="check-icon"/>
                    </button>
                    <span>Kamyon garajı yoğunluk bilgisi gözüksün</span>
                </CheckboxContainer>
            </div>

        </div>
        <div className="bottom-container">
            <Btn bgColor="transparent" color="#E85446" borderColor="#E85446" handleClick={()=> dispatch(handleCustomizer(false))} width={"140px"}>
                Kapat
            </Btn>
            <Btn bgColor="#E85446" handleClick={()=> {}} width={"140px"}>
                Sıfırla
            </Btn>
        </div>

    </Container>
  )
}

export default CustomizerContainer